import { Utils } from '../../../../../../../core/utils/utils';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Rols } from 'src/app/core/entities/rols.model';
import { RolsService } from 'src/app/core/repositories/rols.service';
import { BOOLEAN_OPTION, DESHAB_EXTERNA_DESC, PETICIONES } from '../../../../../../../core/utils/constants';

@Injectable()
export class EditDialogsRolInternalService {

    rolsInternal: Rols = new Rols();
    originalRolsInternal: Rols = new Rols();
    rolsInternalInput: Rols = new Rols();

    allRolsInternal: Rols[] = [];
    changetitulo: boolean = false;

    proveidor: any[] = BOOLEAN_OPTION;
    quickview: any[] = BOOLEAN_OPTION;

    constructor(private rolsInternalService: RolsService) { }

    /**
    * Inicia el dialog
    * @param data Datos recibidos por el dialog
    */
    init(data: any): Observable<boolean> {
        this.rolsInternal = data.rolsInternal;
        this.changetitulo = data.titulochange;
        this.originalRolsInternal = _.cloneDeep(this.rolsInternal);
        console.log(data);
        return this.rolsInternalService.findAll().pipe(map((result: Rols[]) => {
            this.allRolsInternal = result;
            if (Utils.noUndfAndNull(data.rolsInternal)) {
              this.rolsInternal = _.cloneDeep(data.rolsInternal);
            }
            return true;
        }));
    }

    /**
    * @description
    * Guarda el rol interno
    */
    public guardar(): Observable<any> {
        console.log('guardar');
        if (Utils.noUndfAndNull(this.rolsInternal.code, "")) {

        /*comparamos el rol externo original con el modificado*/
        let compareText = this.compare(this.rolsInternal, this.originalRolsInternal);

        if(compareText){
            return of(-1);
        }else{
            return this.rolsInternalService.postRolsInternal(this.rolsInternal);
        }

        } else {
            return this.rolsInternalService.postRolsInternal(this.rolsInternal);
        }
    }

    /**
    * @description
    * Comprueba si dos Roles internos son iguales.
    * @param datoX Rol interno 1
    * @param datoY Rol interno 2
    * @returns True si son iguales
    */
    public compare(itemX:Rols, itemY:Rols):boolean {
        //Ambos objetos están definidos y no son nulos
        if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

            if (itemX.proveidor !== null) {
                let value = itemX.proveidor.toString();
                if (value === 'null') {
                itemX.proveidor = 0;
                }
            }

            if (itemX.quickview !== null) {
                let value = itemX.quickview.toString();
                if (value === 'null') {
                itemX.quickview = 0;
                }
            }

            
            if ((!Utils.compareTextOrNumber(itemX.code, itemY.code)
                 || !Utils.compareTextOrNumber(itemX.desc, itemY.desc)
                 || !Utils.compareTextOrNumber(itemX.priority, itemY.priority)
                 || !Utils.compareTextOrNumber(itemX.rolldap, itemY.rolldap)
                 || !Utils.compareTextOrNumber(itemX.quickview, itemY.quickview)
                 || !Utils.compareTextOrNumber(itemX.proveidor, itemY.proveidor))
                 && (itemX.code !== ""
                 && Utils.noUndfAndNull(itemX.proveidor)
                 && Utils.noUndfAndNull(itemX.quickview)))
                    return false;
        //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
        }else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
            return false;
        }
        return true;
    }

    /**
    * @description
    * Asigna a las propiedades del servicio sus valores por defecto
    */
    build() {
        this.rolsInternal = new Rols();
    }

}